<template>
  <!-- 视频 -->
  <div v-if="video.Materials">
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ video.Name }}</p>
    </div>

    <div v-if="video.Materials.length > '0'" class="bottom_content">
      <van-swipe
        lazy-render
        :show-indicators="false"
        @change="(i) => onChange(i)"
      >
        <van-swipe-item v-for="d in video.Materials" :key="d.AssetId">
          <!-- required:{{ required }} --- Completed:{{ d.Completed }} -->
          <VideoPlayer
            v-if="d.Asset"
            :ref="'video'"
            :class="{ 'is-audio': isAudio }"
            :data="d"
            :is-must-play="required"
            :options="getOption(d)"
            @canplay="onPlayerCanplay($event)"
            @canplaythrough="onPlayerCanplaythrough($event)"
            @ended="onPlayerEnded($event, d.DeliveryId)"
            @loadeddata="onPlayerLoadeddata($event)"
            @pause="onPlayerPause($event, d.DeliveryId)"
            @play="onPlayerPlay($event)"
            @playCompleted="onPlayCompleted(d)"
            @playing="onPlayerPlaying($event)"
            @ready="playerReadied"
            @statechanged="playerStateChanged($event)"
            @timeupdate="onPlayerTimeupdate($event, d.DeliveryId)"
            @waiting="onPlayerWaiting($event)"
          />
          <div v-if="video.isShow" class="xq"></div>
        </van-swipe-item>
      </van-swipe>
      <div class="video-title">
        {{ video.Materials[video.lbIndex].MaterialName }}
      </div>
      <div class="custom-indicator">
        <ul v-if="video.Materials.length > 1">
          <li
            v-for="(e, i) in video.Materials"
            :key="i + 'j'"
            :class="i === video.lbIndex ? 'active' : ''"
          ></li>
        </ul>
      </div>
    </div>
    <van-empty v-else description="暂无视频" image-size="40" />
  </div>
</template>

<script>
  import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
  import VideoPlayer from '@/components/VideoPlayer'
  import store from '@/store'

  import api from '@/api'
  export default {
    components: {
      VideoPlayer,
    },
    props: {
      video: {
        type: Object,
        default() {
          return {}
        },
      },
      required: {
        type: Boolean,
        default: false,
      },
      ind: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        playTime: 0, // ms
        isAudio: false, //是否是音频
        audioType: [
          'MP3',
          'OGG',
          'WAV',
          'WMA',
          'APE',
          'FLAC',
          'AAC',
          'AC3',
          'MMF',
          'AMR',
          'M4A',
          'M4R',
          'WV',
          'MP2',
        ],
      }
    },
    mounted() {},
    methods: {
      // 播放完成
      onPlayCompleted(d) {
        d.Completed = true
      },
      onPlayerPlay($event) {
        // console.log($event)
      },
      onPlayerPause(options, deliveryId) {
        const progress = options.currentTime
        this.setRecordDeliveryPalyTime(
          deliveryId,
          parseInt(progress),
          parseInt(this.playTime / 1000)
        )
      },
      onPlayerEnded(options, deliveryId) {
        const progress = options.currentTime
        this.setRecordDeliveryPalyTime(
          deliveryId,
          parseInt(progress),
          parseInt(this.playTime / 1000)
        )
      },
      onPlayerWaiting($event) {
        // console.log($event)
      },

      onPlayerTimeupdate(options, deliveryId) {
        this.playTime = this.playTime + 240
        const progress = options.currentTime
        if (this.playTime >= 15000) {
          this.setRecordDeliveryPalyTime(
            deliveryId,
            parseInt(progress),
            parseInt(this.playTime / 1000)
          )
        }
      },
      onPlayerCanplay($event) {
        // console.log($event)
      },
      onPlayerCanplaythrough($event) {
        // console.log($event)
      },
      playerStateChanged($event) {
        // console.log($event)
      },
      playerReadied($event) {
        // console.log($event)
      },
      // 设置播放时间
      setRecordDeliveryPalyTime(deliveryId, progress, playTime) {
        const params = {
          deliveryId,
          progress,
          playTime,
          formId: this.$route.params.id,
        }
        //设置播放时间
        store.dispatch('service/RecordDeliveryPalyTime', params).then((res) => {
          if (res.Code === 0) {
            //console.log('res :>> ', res.Data)
          }
        })
        this.playTime = 0
      },
      getOption(data) {
        const option = {
          init: false,
          autoplay: false,
          language: 'zh-CN',
          controls: true,
          fluid: false,
          //preferFullWindow: true,
          playsinline: true,
          metadataTrack: false,
          playbackRates: [0.5, 1.0, 1.25, 1.5, 2.0],
          poster: data.Asset && data.Asset.BaseInfo.CoverInfoArray[0].CoverUrl,
          notSupportedMessage: '暂无法播放，请稍后再试',
          currentTime: data.Progress,
          controlBar: {
            timeDivider: true,
            durationDisplay: true, //视频时长时间显示
            remainingTimeDisplay: false, //剩余时间显示
            fullscreenToggle: true, // 全屏按钮
          },
          // errorDisplay: false, //错误显示

          bigPlayButton: true, //视频中间的播放按钮显示
          // sources: [
          //   {
          //     src: data.Asset && data.Asset.TranscodeInfo.Output[0].Url,
          //     type: 'application/x-mpegURL',
          //   },
          // ],
        }

        // 全部采用m3u8流播放 如果没有转换成功或转换 则取原始地址
        if (data.Asset && data.Asset.TranscodeInfo.Output.length) {
          console.log(data.Asset.BaseInfo.VideoName + '采用m3u8流播放')
          let url = ''
          data.Asset.TranscodeInfo.Output.forEach((item) => {
            if (item.MetaData.VideoSize) {
              url = item.Url
            }
          })
          console.log(url)
          option.sources = [
            {
              src: url,
              type: 'application/x-mpegURL',
            },
          ]
        } else {
          const type = data.Asset.BaseInfo.VideoType.toLowerCase()
          console.log(`${data.Asset.BaseInfo.VideoName} 采用原始${type}播放`)
          const url = data.Asset && data.Asset.BaseInfo.VideoUrl
          console.log(url)
          // 未转码取原始地址
          option.sources = [
            {
              src: url,
              type: this.audioType.includes(data.Asset.BaseInfo.VideoType)
                ? 'audio/' + type
                : 'video/' + type,
            },
          ]
        }

        if (!this.audioType.includes(data.Asset.BaseInfo.VideoType)) {
          this.isAudio = false
        } else {
          this.isAudio = true
          // 音频
          if (this.audioType.includes(data.Asset.BaseInfo.VideoType)) {
            option.poster = require('@/assets/images/audio.png')
            option.audioPosterMode = true
            option.bigPlayButton = false
          }
        }

        return option
      },
      onChange(i) {
        this.video.lbIndex = i
        this.$refs['video'].length &&
          this.$refs['video'].forEach((item) => {
            item.pause()
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
  }
  .my-swipe {
    position: relative;
    #play {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba($color: #000000, $alpha: 0.7);
      z-index: 5;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
      }
    }
  }
  .custom-indicator {
    margin-top: 10px;
    ul {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      li {
        width: 4px;
        height: 4px;
        margin: 0 2px;
        background: #dbdbdd;
        border-radius: 50%;
      }
      li.active {
        width: 16px;
        height: 4px;
        background: #b57e48;
        border-radius: 5px;
      }
    }
  }

  .bottom_content {
    padding: 15px;
  }

  .video-title {
    font-size: 14px;
    padding: 6px 0 0;
    color: #666;
    text-align: center;
  }

  .is-audio {
    :deep(.vjs-has-started .vjs-control-bar) {
      opacity: 1;
    }
    :deep(.vjs-control-bar) {
      display: flex !important;
    }
  }
</style>
